<div class="background d-flex align-items-center p-4 p-xl-0">
  <div class="container d-flex flex-column text-center">
    <div class="">
      <img
        src="../../../assets/img/error404.png"
        alt="Errore"
       
        class="error-img img-fluid"
      />
    </div>
    <div class="">
      <h1>
        Sei ai confini di Easycode.<br />Floppy non trova la pagina, riportalo a
        casa.
      </h1>
    </div>
    <a href="/home">
      <button class="btn-lightblue mt-5">
        <span class="button-txt">Torna in Homepage</span>
      </button>
    </a>
  </div>
</div>
